import {
  IsBoolean,
  IsInt,
  IsNotEmpty,
  IsOptional,
  Min,
  ValidateIf,
} from 'class-validator';
import { constants } from '../../shared/utils-v2/constants';
import { MaxFundedBeds } from '../../validators-v2/base/max-number.validator';

export class FacilityBedEmptyReasonFormDTO {
  @IsBoolean({
    message: constants.app_settings.validation_message.SINGLE_CHOICE,
  })
  @IsNotEmpty({
    message: constants.app_settings.validation_message.IS_REQUIRED,
  })
  hasEmptyBeds: boolean | undefined;

  // For validation
  @IsInt()
  @IsOptional()
  fundedBeds: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  openBedLessTwoWeekReferral: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  openBedTwoWeekNoReferral: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchPhysical: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchSmoking: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchPeerGender: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchEquipment: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchCognitive: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  bedMismatchClientRefusal: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  onHoldPendingOrMatched: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  tempCloseMaintenance: number | undefined;

  @ValidateIf((o) => o.hasEmptyBeds === true)
  @IsInt()
  @IsOptional()
  @MaxFundedBeds((o) => o.fundedBeds, {
    message:
      constants.app_settings.validation_message.LESS_THAN_FUNDED_BEDS_COUNT,
  })
  @Min(0, {
    message: constants.app_settings.validation_message.POSITIVE_NUMBER_ONLY,
  })
  tempCloseOther: number | undefined;
}
